import{VERSION_STORAGE_KEY as t}from"../../../constants/VERSION_STORAGE_KEY/VERSION_STORAGE_KEY.js";var o=function(o,r){return void 0===r&&(r=t),localStorage.setItem(btoa(String(r)),btoa(o))};export{o as setVersion};
//# sourceMappingURL=setVersion.js.map
